<template>
  <div class="backdrop">
      <div class="modal">
            <h2>Frequenzen und Fluggewichte </h2>
            <form  @submit.prevent="signIn" >
                <div class="checkbox-group">
                    <div class="input-line">
                        <input v-model="pilotLog.twoPointFourGHz" type="checkbox">
                        <label >2,4 GHz Anlage</label>
                    </div>
                    <div class="input-line">
                        <input v-model="pilotLog.thirtyFiveMHz" type="checkbox">
                        <label >35 MHz Anlage</label>
                    </div>
                    <div class="input-line">
                        <input v-model="pilotLog.belowFiveKG" type="checkbox">
                        <label> Modelle unter 5 kg </label>
                    </div>
                    <div class="input-line">
                        <input v-model="pilotLog.aboveFiveKG" type="checkbox">
                        <label > Modelle über 5 kg</label>
                    </div>
                </div>

                <input type="submit" value="Als Pilot eintragen" > 


 
            </form>
            <button @click="cancelSignInPilot" class="cancel">Abbrechen</button>

      </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';


export default {
    name: 'Modal',
    setup(props, context) {
        const store = useStore()
        const pilotLog = ref ({
            date:null,
            user: store.state.user,
            resource: store.state.resource,
            startTime: null,
            endTime: null,
            twoPointFourGHz: true,
            thirtyFiveMHz:false,
            belowFiveKG: true,
            aboveFiveKG:false
        })
        
        const signIn = () => {
            context.emit('signInPilot', pilotLog.value)
        } 

        const cancelSignInPilot = () => {
            context.emit('cancelSignInPilot')
        }
        
        return {pilotLog, signIn, cancelSignInPilot}
    }

}
</script>

<style scoped>
.modal {
    width: 300px;
    padding: 20px;
    margin: 200px auto;
    background: white;
    border-radius: 10px;
}

.backdrop {
    top: 0;
    position: fixed;
    background: rgba(0,0,0,0.5);
    width: 100%;
    height:100%;
}

.checkbox-group {
  width: 80%;
  margin: 10px auto;
  background: white;
  text-align: left;
  padding: 10px 0;
  border-radius: 15px;
  box-sizing: border-box;
}

.input-line {
    
    font-size: 16px;
    padding: 10px 0;
}


input[type="checkbox"]{
    display:inline-block;
    width: 20px;
    margin: 0 10px 0 0;
    position: relativ;
    top: 2px;
}

input[type="submit"]{
    width: 80%;
    color: white;
    background-color: crimson;
    border-radius: 20px;
    padding: 10px 15px;
    border:none;
    font-size: 16px;
}

.cancel{
    width: 80%;
    background-color: #f2f2f2;
    padding: 10px 15px;
    margin: 20px 0;
    border-radius: 20px;
    border:none;
    font-size: 16px;
}

</style>